var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import PropTypes from "prop-types";
import id from "@irati/utils/id";
import { get, isEqual } from "lodash";
import Flex from "@irati/ui/src/Flex";
import { getResolvedMessage, injectIntl } from "@irati/utils/lang";
import ValidationInput from "@irati/utils/validation/Input";
import RadioOption from "./RadioOption";
import { RadioGroupLabel, RadioGroupError } from "./styled";
var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.validation = new ValidationInput(_this);
        _this.state = {
            errorMsg: undefined
        };
        _this.handleChange = function (index) {
            var _a = _this.props, onChange = _a.onChange, options = _a.options;
            var newValue = options[index].value;
            onChange(options[index].value, options[index]);
            _this.setState({
                value: newValue
            });
        };
        _this.compareValueToOption = function (value, option) {
            var equateBy = _this.props.equateBy;
            if (equateBy) {
                return isEqual(get(value, equateBy), get(option, equateBy));
            }
            return isEqual(value, option.value);
        };
        return _this;
    }
    Radio.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.value !== prevState.value) {
            return { value: nextProps.value };
        }
        else
            return null;
    };
    Radio.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.validation.update(prevProps, prevState);
    };
    Radio.prototype.componentWillUnmount = function () {
        this.validation.destroy();
    };
    Radio.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, options = _a.options, className = _a.className, disabled = _a.disabled, label = _a.label, inline = _a.inline, rowRenderer = _a.rowRenderer, justifyRadios = _a.justifyRadios, whiteSpace = _a.whiteSpace;
        var _b = this.state, errorMsg = _b.errorMsg, value = _b.value;
        var idNamespace = id("radioGroup", name);
        return (React.createElement(React.Fragment, null,
            label && (React.createElement(RadioGroupLabel, { id: id("label", idNamespace), error: !!errorMsg }, getResolvedMessage(this, "label"))),
            React.createElement(Flex, { justifyContent: justifyRadios || "space-between", wrap: "wrap" }, options.map(function (option, index) { return (React.createElement(RadioOption, { id: id(index + "_", idNamespace), name: name, key: index, value: index, option: option, onChange: _this.handleChange, checked: _this.compareValueToOption(value, option), inline: !!inline, disabled: !!disabled, className: className, whiteSpace: whiteSpace, rowRenderer: rowRenderer })); })),
            errorMsg && React.createElement(RadioGroupError, { small: true }, getResolvedMessage(this, "errorMsg", this.state))));
    };
    Radio.contextTypes = {
        currentScreen: PropTypes.string
    };
    return Radio;
}(Component));
export default injectIntl(Radio);
